import { store } from "../store/store";
import type { RootState } from "../store/store";
import { selectQlikVariableByName, setQlikCalcVariables, setQlikVariable } from "../store/slice/qlikVariableSlice";
import { getQlikApp } from "./qlikService";
import { gtm } from "./gtm";
import { CYBER_CONFIG } from "../constants";
import { showSnackbar } from "../store/slice/snackbarSlice";

const dispatch = store.dispatch;
// Get the Redux state
const getState = (): RootState => store.getState();

async function readVariableData(appName: string, varObjName: string, varName: string, variable: any): Promise<any> {
  const variableLayout = await variable.getLayout();
  const variableFreshLayout = JSON.parse(JSON.stringify(variableLayout)); //Workaround to avoid error on qlik/api when dispatching the object
  dispatch(setQlikVariable({ appName, name: varName, object: variableFreshLayout }));
  dispatch(setQlikCalcVariables({ varObjName, variableName: varName, variableValue: variableFreshLayout.qNum == 'NaN' ? variableFreshLayout.qText : variableFreshLayout.qNum }));
  return variableLayout
}

// Fetch variable content by variable name
export async function getVariableContentByName(varObjName: string, varName: string, appRef: string): Promise<string | null> {
  try {
    const qlikApp = await getQlikApp(appRef);
    if (qlikApp) {
      const state = getState();
      //If variable already exist in the store, I will not read it from Qlik again
      if(!selectQlikVariableByName(state, varName)) {
        const variable = await qlikApp.getVariableByName(varName);
        // const variableData = await variable.getLayout();
        const variableLayout = await readVariableData(appRef, varObjName,varName, variable);
            
        //Handling new selections applied
        variable.on('changed', async () => {
          await readVariableData(appRef, varObjName, varName, variable);
        });
        return variableLayout;
      }
    }
    return null;
  } catch (error) {
    console.error(`Error fetching variable content for variable: ${varName} in appRef: ${appRef}`, error);
    dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
    return null;
  }
}

// Set variable value by name
export async function setVariableByName(varObjName: string, varName: string, newValue: string | number, appName: string, formName: string): Promise<any> {
  try {
    const qlikApp = await getQlikApp(appName);
    if (qlikApp) {
      dispatch(setQlikCalcVariables({ varObjName, variableName: varName, variableValue: newValue }));
      const variable = await qlikApp.getVariableByName(varName);
      gtm.formEvent(`Variable Change: ${varName}: ${newValue}`, formName);
      if (isNaN(Number(newValue))) {
        // Set string value
      //   return await qlikApp.variable.setStringValue(varName, newValue as string);
          return await variable.setStringValue(newValue as string);
      } else {
        // Set numeric value
        return await variable.setNumValue(Number(newValue));
      }
    }
    return null;
  } catch (error) {
    console.error(`Error setting variable value for variable: ${varName} in appRef: ${appName}`, error);
    dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
    return null;
  }
}

export default {
  getVariableContentByName,
  setVariableByName
};